var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUploadImg = function SvgIconUploadImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 7h26a3 3 0 0 1 3 3v20a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3Zm-1 19.41V30a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-.586l-7.358-7.36-3.872 2.764a2 2 0 0 1-2.45-.097l-.126-.116-6.194-6.19-8 7.995Zm28 .175-5.944-5.945-.126-.116a2 2 0 0 0-2.45-.098l-3.872 2.765L15.914 17l-.127-.117a2.002 2.002 0 0 0-2.7.116L6.5 23.582V10a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v16.585Zm-3-12.085a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
    fill: "#C6C8CC"
  })));
};
export default SvgIconUploadImg;